import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import Paper from '@material-ui/core/Paper';
import Error from '../Error';

const AssetsError = ({ error, classes }) => (
    <Paper square elevation={1} className={classes.wrapper}>
        <Error>{error}</Error>
    </Paper>
);

AssetsError.propTypes = {
    error: PropTypes.string.isRequired,
};

const style = ({ spacing }) => ({
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        maxWidth: spacing.maxWidth,
        padding: [0, spacing.unit * 4],
    },
});

export default injectSheet(style)(AssetsError);



// WEBPACK FOOTER //
// ./src/components/assets/AssetsError.js